import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { BiRadioCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { addExchangeListingAxios } from "../../Actions/axios";
import { toast } from "react-toastify";
import { isEmpty } from "../../Actions/common";
import SunEditor from "suneditor-react";



const ExchangeAdd = () => {
  const navigate = useNavigate();

  const [pageName, setPageName] = useState("");
  const [additemsubtitle, setAdditemsubtitle] = useState(false);
  const [addinstructions, setAddinstructions] = useState(false);
  const [otpsend, setOtpsend] = useState(false);
  const [inputs, setInputs] = useState([
    {
      "subheading": "",
      "instruction": "",
      "addinstructions": false,
      "subinputs": [
        {
          type: "",
          required: false,
          additem: false,
          name: "",
          content: [],
          options: []
        }
      ]
    }
  ]);
  const [maintitle, setMaintitle] = useState("");
  console.log("inputs", inputs)
  const [subtitleHeading, setSubtitleHeading] = useState("");
  const addQuestion = () => {
    setInputs([
      ...inputs,
      {
        type: "",
        required: false,
        additem: false,
        addinstructions: false,
        otpcheck: false,
        otptype: "",
        name: "",
        content: [],
        options: [],
        instruction: "",
        addinstructions: false
      }
    ]);
  };
  console.log("additemsubtitle", additemsubtitle, subtitleHeading, addinstructions)
  const removeQuestion = (index) => {
    const list = [...inputs];
    list.splice(index, 1);
    setInputs(list);
  };

  // const handleChange = (e, index) => {
  //   const { id, value, checked, type } = e.target;

  //   setInputs((prev) => {
  //     const updated = [...prev];
  //     updated[index] = {
  //       ...updated[index],
  //       [id]: type === "checkbox" ? checked : value
  //     };
  //     return updated;
  //   });
  // };

  const handleChangeotp = (event) => {
    setOtpsend(event.target.checked);
  };


  const handleOptionChange = (e, inputIndex, optionIndex) => {
    const { value } = e.target;

    setInputs((prev) => {
      const updated = [...prev];
      const options = [...(updated[inputIndex]?.options || [])];
      options[optionIndex] = value;
      updated[inputIndex].options = options;
      return updated;
    });
  };

  const addOption = (inputIndex) => {
    setInputs((prev) => {
      const updated = [...prev];
      const options = [...(updated[inputIndex]?.options || [])];
      options.push("");
      updated[inputIndex].options = options;
      return updated;
    });
  };

  const removeOption = (inputIndex, optionIndex) => {
    setInputs((prev) => {
      const updated = [...prev];
      const options = [...(updated[inputIndex]?.options || [])];
      options.splice(optionIndex, 1);
      updated[inputIndex].options = options;
      return updated;
    });
  };

  const handleSubmit = async () => {
    let validation = inputs?.some((el) => el?.type !== "MultiQuestion" ? (el?.type === "" || el?.name === "" || !el?.name) : false);
    const subheadingcheck = inputs?.some((val) => val?.type == "MultiQuestion" && val?.subheading == "")
    const otpFieldCheck = inputs?.some((val) => val?.type == "Shortanswer" && val?.otpcheck ? (val.otptype == "" || !val.otptype) : false)
    console.log("otpFieldCheck",otpFieldCheck);
    

    console.log('validationvalidation', validation);
    let optionValidation = inputs?.some((el) =>
      Array.isArray(el?.options) &&
      el?.options?.length > 0 &&
      el?.options?.some((opt) => typeof opt === "string" && opt.trim() === "")
    );

    if (isEmpty(pageName)) {
      return toast.error("Item name is required.")
    }
    if (validation) {
      return toast.error("Type or Question is required.")
    }
    if (optionValidation) {
      return toast.error("Options is required.")
    }
    if (subheadingcheck) {
      return toast.error("Main heading is required.")
    }
    if (otpFieldCheck) {
      return toast.error("OTP option is required.")
    }
    const finalData = {
      section: "exchange",
      additemsubtitle: additemsubtitle,
      subtitleHeading: subtitleHeading ? subtitleHeading : "",
      stepName: pageName,
      inputs: inputs
    };
    // const finalData = {
    //   section: "exchange",
    //   stepName: pageName,
    //   subtitles: [
    //     {
    //       heading: maintitle,
    //       inputs: inputs
    //     }
    //   ]
    // };
    console.log("Final Submission Payload:", finalData);
    const resp = await addExchangeListingAxios(finalData)
    console.log("resprespresp", resp)
    if (resp?.status) {
      toast.success(resp?.message)
      navigate("/exchangelist")
    }
    // API call here
  };


  const [filterRows, setFilterRows] = useState([{ label: "" }]);
  const addFilters = (parentIndex) => {
    const newInputs = [...inputs];
    newInputs[parentIndex].subinputs.push({
      type: "",
      required: false,
      additem: false,
      name: "",
      content: [],
      options: [],
    });
    setInputs(newInputs);
  };
  const removeFilters = (index) => {
    const list = [...filterRows]
    list.splice(index, 1)
    setFilterRows(list)
  };
  const handleInputChange = (index, type, value) => {
    const list = [...filterRows];
    list[index][type] = value;
    setFilterRows(list);
  };

  const handleChange = (e, index, subIndex = null, suneditor = "") => {
    console.log("subIndexsubIndex", index, subIndex, suneditor)
    const updatedInputs = [...inputs];
    console.log("updatedInputs",updatedInputs);
    
    if (suneditor == "suneditor") {
      updatedInputs[index]["instruction"] = e;
    }
    else if (suneditor == "mail") {
      updatedInputs[index]["otptype"] = suneditor;
    }
    else if (suneditor == "mobile") {
      updatedInputs[index]["otptype"] = suneditor;
    }
    else {
      const { id, value, checked, type } = e?.target;
      console.log("bbbbbbbbb", id, value, checked, type)
      if (subIndex !== null) {
        console.log("MULTIPLEQUESTIONSSSss")
        updatedInputs[index].subinputs[subIndex][id] = type === "checkbox" ? checked : value;
      }
      else {
        updatedInputs[index][id] = type === "checkbox" ? checked : value;
        console.log("fffffff", updatedInputs[index][id] = type === "checkbox" ? checked : value, checked, value, updatedInputs[index][id])

        if (id === "type" && value === "MultiQuestion") {
          updatedInputs[index].subheading = "";
          updatedInputs[index].addinstructions = false;
          updatedInputs[index].instruction = "";
          updatedInputs[index].subinputs = [];
        }
      }
    }

    console.log("updatedInputs", updatedInputs)
    setInputs(updatedInputs);
  };

  const removeSubInput = (parentIndex, subIndex) => {
    const updatedInputs = [...inputs];
    updatedInputs[parentIndex].subinputs?.splice(subIndex, 1);
    setInputs(updatedInputs);
  };


  console.log("inputsinputs", inputs)
  return (
    <div className="cmsadd">
      <button className="btn sitebtn mb-4" onClick={() => navigate(-1)}>
        Back
      </button>

      <h1 className="pagehead">Questions</h1>

      <div className="mb-2">
        <label className="form-label">Item Name <span className="reqclr">*</span></label>
        <input
          type="text"
          className="form-control"
          placeholder="Item Name"
          value={pageName}
          onChange={(e) => setPageName(e.target.value)}
        />
      </div>
      <div className="form-check mt-0 mb-2">
        <input
          className="form-check-input"
          type="checkbox"
          checked={additemsubtitle}
          onChange={() => setAdditemsubtitle((prev) => !prev)}

        />
        <label
          className="form-check-label"
        >
          Add Item Subtitle
        </label>
      </div>
      {additemsubtitle &&
        <div className="mb-3">
          <label className="form-label">Item Subtitle</label>
          <input
            type="text"
            className="form-control"
            placeholder="Item Subtitle"
            value={subtitleHeading}
            onChange={(e) => setSubtitleHeading(e.target.value)}
          />
        </div>}


      <div className="d-flex align-items-center justify-content-end">
        <button className="btn sitebtn mb-4" onClick={addQuestion}>
          Add Question
        </button>
      </div>

      {inputs?.length > 0 && inputs?.map((el, i) => {
        console.log("ttttttttttt", el);

        return (
          <div className="cardbox mb-3" key={i}>
            <Form.Select
              onChange={(e) => handleChange(e, i)}
              id="type"
              value={el?.type || ""}
            >
              <option value="">Choose Question Type</option>
              <option value="Shortanswer">Short Answer</option>
              <option value="MultiQuestion">MultiQuestion</option>
              <option value="Dropdown">Dropdown</option>
              <option value="Upload">Upload</option>
              <option value="Calendar">Calendar</option>
              <option value="Radio">Radio</option>
              <option value="Checkbox">Checkbox</option>
              <option value="Paragraph">Paragraph</option>
            </Form.Select>

            {el?.type !== "MultiQuestion" &&
              <div className="mt-3 d-flex gap-3">
                <div>
                  <p className="form-label">Required</p>
                  <input
                    type="checkbox"
                    checked={el?.required}
                    id="required"
                    onChange={(e) => handleChange(e, i)}
                  />
                </div>
                <div className="w-100">
                  <p className="form-label">Question</p>
                  <input
                    type="text"
                    className="form-control"
                    value={el?.name}
                    id="name"
                    placeholder="Question"
                    onChange={(e) => handleChange(e, i)}
                  />
                </div>
              </div>}

            {

              el?.type === "MultiQuestion" && (
                <>
                  <div className="mt-3 mb-3 d-flex align-items-center gap-3">
                    <div>
                      <p className="form-label mb-0">Required</p>
                      <input
                        type="checkbox"
                        checked={el?.required}
                        id="required"
                        onChange={(e) => handleChange(e, i)}
                      />
                    </div>
                    <p className="form-label mb-0">Main Heading: </p>
                    <input
                      type="text"
                      className="form-control"
                      value={el?.subheading}
                      id="subheading"
                      placeholder="Main Heading"
                      onChange={(e) => handleChange(e, i)}
                    />
                  </div>

                  <div className="text-end">
                    <button className="btn sitebtn mb-4" onClick={() => addFilters(i)}>Add Subquestion</button>
                  </div>

                  {el?.subinputs?.map((sub, j) => (
                    <div className="d-flex align-items-center gap-3 mb-3" key={j}>
                      <div>
                        <p className="form-label mb-0">Required</p>
                        <input
                          type="checkbox"
                          checked={sub?.required}
                          id="required"
                          onChange={(e) => handleChange(e, i, j)}
                        />
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        value={sub.name}
                        onChange={(e) => handleChange(e, i, j)}
                        placeholder="Sub Question"
                      />
                      <button className="btn sitebtn" onClick={() => removeSubInput(i, j)}><MdDelete /></button>
                    </div>
                  ))}
                </>
              )}
            {/* {(el.type === "MultiQuestion") &&
            <>
              <div className="mt-3 mb-3 d-flex align-items-center gap-3">
                <div>
                  <p className="form-label mb-0">Required</p>
                  <input
                    type="checkbox" />
                </div>
                <input
                  type="text"
                  className="form-control"
                  value={maintitle}
                  id="name"
                  placeholder="Main title"
                  onChange={(e) => setMaintitle(e.target.value)}
                />
              </div>
              <div className="text-end"><button className="btn sitebtn mb-4" onClick={() => addFilters()}>Add</button></div>
              {inputs.map((e, j) => (
                <div className="d-flex align-items-center gap-3 mb-3" key={j}>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={e.name}
                    onChange={(e) =>
                      // handleInputChange(i, "label", e.target.value)
                      handleChange(e, j)
                    }
                    placeholder="Question"
                  />
                  <button className="btn sitebtn" onClick={() => removeFilters(i)}><MdDelete /></button>
                </div>
              ))}

            </>
          } */}


            {(el?.type === "Dropdown" || el?.type === "Radio" || el?.type === "Checkbox") && (
              <div className="mt-3">
                <h6>Dropdown Options</h6>
                <div className="text-end">
                  <button
                    className="btn sitebtn mb-2"
                    onClick={() => addOption(i)}
                  >
                    Add Option
                  </button>
                </div>
                <div className="row">
                  {el?.options?.length > 0 && (el?.options || []).map((opt, j) => (
                    <div
                      className="col-md-6 col-lg-6 col-xl-6 col-xxl-4"
                      key={j}
                    >
                      <div className="d-flex align-items-center gap-3 mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Option"
                          id="options"
                          value={opt?.options}
                          onChange={(e) => handleOptionChange(e, i, j)}
                        />
                        <MdDelete
                          fontSize={25}
                          className="cursor-pointer"
                          onClick={() => removeOption(i, j)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {(el?.type === "Shortanswer") && (
              <>
              {el.otpcheck ?
              <></>:
                <div className="form-check mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={el?.additem}
                    // id={`addmore-${i}`}
                    id="additem"
                    onChange={(e) => { handleChange(e, i) }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`addmore-${i}`}
                  >
                    Add More
                  </label>
                </div> }
                <div className="form-check mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={el.otpcheck}
                    onChange={(e) => { handleChange(e, i) }}
                    id="otpcheck"
                  />
                  <label
                    className="form-check-label"
                  >
                    Send OTP
                  </label>
                </div>
                {el.otpcheck ?
                  <div className="d-flex gap-3 mt-2">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name={`flexRadioDefault${i}`} id="mail" onChange={(e) => { handleChange(e, i, "", "mail") }} />
                      <label class="form-check-label" for="flexRadioDefault1">
                        Mail OTP
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name={`flexRadioDefault${i}`} id="mobile" onChange={(e) => { handleChange(e, i, "", "mobile") }} />
                      <label class="form-check-label" for="flexRadioDefault2">
                        Mobile OTP
                      </label>
                    </div>
                  </div>
                  :
                  <></>
                }
              </>
            )}

            {(el?.type === "MultiQuestion") && (
              <>
                <div className="form-check mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={el?.additem}
                    // id={`addmore-${i}`}
                    id="additem"
                    onChange={(e) => { handleChange(e, i) }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`addmore-${i}`}
                  >
                    Add More
                  </label>
                </div>

              </>
            )

            }


            <div className="form-check mt-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="addinstructions"
                checked={inputs[i]?.addinstructions}
                onChange={(e) => handleChange(e, i)}
              />
              <label
                className="form-check-label"
              >
                Add Instructions
              </label>
            </div>
            {/* {inputs[i]?.addinstructions &&
            <div className="mb-3">
              <label className="form-label">Instruction</label>
              <input
                type="text"
                className="form-control"
                placeholder="Instruction"
                id="instruction"
                value={inputs[i]?.instruction}
                onChange={(e) => handleChange(e, i)}
              />
               <SunEditor
                      defaultValue={inputs[i]?.instruction ?? '<p>Hello</p>'}
                    onChange={(e) => handleChange(e, i,"","suneditor")}
                    height={300}
                  />
            </div>
          } */}
            {inputs[i]?.addinstructions && (
              <div className="mb-3">
                <label className="form-label">Instruction</label>
                <SunEditor
                  defaultValue={inputs[i]?.instruction ?? "<p>Hello</p>"}
                  onChange={(e) => handleChange(e, i, null, "suneditor")}
                  height={300}
                />
              </div>
            )}
            <div className="text-end mt-2">
              <button
                className="btn btn-danger"
                onClick={() => removeQuestion(i)}
              >
                <MdDelete />
              </button>
            </div>
          </div>
        )
      })}

      <button className="btn sitebtn mt-4" onClick={handleSubmit}>
        Submit
      </button>
    </div>
  );
};

export default ExchangeAdd;



